/**
 * mulberry32 — the ONLY random source allowed in gameplay code.
 * Deterministic across platforms (pure uint32 ops). Math.random() is banned
 * in gameplay by lint rule and by law (Section 2: determinism is sacred).
 */
export type Rng = () => number;

/** Returns a function producing floats in [0, 1). */
export function mulberry32(seed: number): Rng {
  let a = seed >>> 0;
  return () => {
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/** Hash a string (e.g. "20260806") to a uint32 seed. FNV-1a. */
export function seedFromString(s: string): number {
  let h = 0x811c9dc5;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return h >>> 0;
}
